export type Market = "SE" | "NO";

export interface MarketConfig {
  code: Market;
  name: { en: string; sv: string; no: string };
  defaultCenter: [number, number]; // [lng, lat]
  defaultZoom: number;
  currency: string;
  propertyIdPrefix: string;
  administrativeHierarchy: string[];
}

export const MARKETS: Record<Market, MarketConfig> = {
  SE: {
    code: "SE",
    name: { en: "Sweden", sv: "Sverige", no: "Sverige" },
    defaultCenter: [15.5, 62.0], // Center of Sweden
    defaultZoom: 4.5,
    currency: "SEK",
    propertyIdPrefix: "se",
    administrativeHierarchy: ["county", "municipality"],
  },
  NO: {
    code: "NO",
    name: { en: "Norway", sv: "Norge", no: "Norge" },
    defaultCenter: [12.0, 64.5], // Center of Norway
    defaultZoom: 4.5,
    currency: "NOK",
    propertyIdPrefix: "no",
    administrativeHierarchy: ["county", "municipality"],
  },
};
